import { ArrowLeft, LogIn } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { DeniedState } from "../../components/patterns";

const NotAuth = () => {
  const navigate = useNavigate();

  return (
    <main className="portal-page">
      <DeniedState
        size="page"
        title="Access denied"
        description="Your account is not permitted to view this page. Sign in with an account that has access, or go back."
        actions={
          <>
            <Button type="button" variant="outline" onClick={() => navigate(-1)}>
              <ArrowLeft className="h-4 w-4" aria-hidden="true" />
              Go back
            </Button>
            <Button type="button" onClick={() => navigate("/login")}>
              <LogIn className="h-4 w-4" aria-hidden="true" />
              Sign in
            </Button>
          </>
        }
      />
    </main>
  );
};

export default NotAuth;
